// Icons drawn for the app where Font Awesome Pro 5.15.1 has no match. bin/generate_fontawesome_icons.rb leaves
// this file alone.

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

// Three centred bars, shortening downwards: the shape Font Awesome 6 calls bars-filter, drawn at the stroke weight
// of the regular icons.
export const faBarsFilter = {
  prefix: 'far',
  iconName: 'bars-filter',
  icon: [
    512,
    512,
    [],
    'e0ad',
    'M56 104h400a24 24 0 0 1 0 48H56a24 24 0 0 1 0-48zm80 128h240a24 24 0 0 1 0 48H136a24 24 0 0 1 0-48zm80 128h80a24 24 0 0 1 0 48h-80a24 24 0 0 1 0-48z',
  ],
} as IconDefinition
